module.exports = __webpack_public_path__ + "img/la.3c017d0a.svg";